import { createContext, useCallback, useContext, useRef, useState } from "react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "./ui/alert-dialog";
import { AlertTriangle } from "lucide-react";

const ConfirmContext = createContext(null);

export function ConfirmProvider({ children }) {
  const [opts, setOpts] = useState(null);
  const resolver = useRef(null);

  const confirm = useCallback((o) => new Promise((resolve) => {
    resolver.current = resolve;
    setOpts(typeof o === "string" ? { title: o } : o);
  }), []);

  const close = (val) => {
    resolver.current?.(val);
    resolver.current = null;
    setOpts(null);
  };

  const destructive = opts?.destructive !== false;
  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      <AlertDialog open={!!opts} onOpenChange={(o) => { if (!o) close(false); }}>
        <AlertDialogContent className="bg-white border-[#E4E7EC] max-w-md" data-testid="confirm-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle className="flex items-center gap-2 text-lg" data-testid="confirm-dialog-title">
              <AlertTriangle className={`w-5 h-5 ${destructive ? "text-rose-600" : "text-orange-500"}`} />
              {opts?.title}
            </AlertDialogTitle>
            {opts?.description && <AlertDialogDescription className="text-neutral-600 text-sm">{opts.description}</AlertDialogDescription>}
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel onClick={() => close(false)} data-testid="confirm-dialog-cancel">{opts?.cancelText || "Cancel"}</AlertDialogCancel>
            <AlertDialogAction
              onClick={() => close(true)}
              data-testid="confirm-dialog-confirm"
              className={destructive ? "bg-rose-600 hover:bg-rose-700 text-white" : "bg-orange-500 hover:bg-orange-600 text-white"}>
              {opts?.confirmText || "Delete"}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </ConfirmContext.Provider>
  );
}

export const useConfirm = () => useContext(ConfirmContext);
